<div class="modal-overlay" *ngIf="open" (click)="close()">
  <div class="modal-container" (click)="$event.stopPropagation()">

    <div class="modal-header">
      <span class="modal-title">{{ 'pages.planDetails.PlanHistoryModal.title' | i18n }}</span>
      <i class="bi bi-x-circle close-icon" (click)="close()" aria-hidden="true"></i>
    </div>

    <div class="modal-body">
      <ng-container *ngIf="isLoading; else contentTpl">
        <p class="loading-message">{{ 'pages.planDetails.PlanHistoryModal.loading' | i18n }}</p>
      </ng-container>

      <ng-template #contentTpl>
        <ng-container *ngIf="hasError; else dataTpl">
          <p class="error-message">{{ 'pages.planDetails.PlanHistoryModal.error' | i18n }}</p>
        </ng-container>
      </ng-template>

      <ng-template #dataTpl>
        <ng-container *ngIf="history.length > 0; else emptyTpl">
          <div class="history-table-wrapper">
            <table class="history-table">
              <thead>
                <tr>
                  <th>{{ 'pages.planDetails.PlanHistoryModal.columns.date' | i18n }}</th>
                  <th>{{ 'pages.planDetails.PlanHistoryModal.columns.productName' | i18n }}</th>
                  <th>{{ 'pages.planDetails.PlanHistoryModal.columns.quantity' | i18n }}</th>
                  <th>{{ 'pages.planDetails.PlanHistoryModal.columns.action' | i18n }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let entry of history" [class]="'row-action--' + entry.action">
                  <td class="date-cell">
                    {{ entry.dateTime | date:'HH:mm' }}
                    <span class="date-separator">{{ entry.dateTime | date:'dd-MM-yyyy' }}</span>
                  </td>
                  <td>{{ entry.productName }}</td>
                  <td>{{ entry.quantity }}</td>
                  <td>
                    <span class="action-badge" [class]="'action-badge--' + entry.action">
                      {{ actionKey(entry.action) | i18n }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>
      </ng-template>

      <ng-template #emptyTpl>
        <p class="empty-message">{{ 'pages.planDetails.PlanHistoryModal.empty' | i18n }}</p>
      </ng-template>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn" (click)="close()">
        {{ 'pages.planDetails.PlanHistoryModal.close' | i18n }}
      </button>
    </div>

  </div>
</div>
